import React from 'react';
import { CTAButton } from './CTAButton';
import { TrustRow } from './TrustRow';
import { OFFER_ANCHOR, PRODUCT_ALT, PRODUCT_IMG } from './constants';
export function Hero() {
  return <section className="bg-white px-3 pb-2 pt-3 sm:px-4" data-id="element-76" data-mp="9kjvumdkz02m">
      <div className="mx-auto max-w-3xl text-center" data-id="element-77" data-mp="9l32h6xs621c">
        <h1 className="mb-1.5 font-display text-[24px] font-extrabold uppercase leading-[1.03] tracking-tight text-eq-navy sm:text-[42px]" data-id="element-78" data-mp="4mi2n8mfxkdf">
          The Complete Ready-to-Use System for{' '}
          <span className="text-eq-gold" data-id="element-79" data-mp="x9urjpg2q49w">Horse Riding Instructors</span>
        </h1>
        <p className="mx-auto mb-1 max-w-2xl text-[13px] font-medium leading-snug text-eq-muted sm:text-base" data-id="element-80" data-mp="sbb57nxkiqh0">
          Stop spending hours planning lessons, choosing exercises, adapting activities, and
          preparing resources for every rider.
        </p>
        <p className="mx-auto mb-1.5 max-w-2xl text-[13px] font-bold leading-snug text-eq-navy sm:text-base" data-id="element-81" data-mp="3d2tod9lewkej">
          Everything you need to teach is finally organized in one professional system.
        </p>

        <a href={OFFER_ANCHOR} className="mb-1.5 block" aria-label="Go to the purchase section" data-id="element-82" data-mp="3j6fx1mlet7c9">
          <img src={PRODUCT_IMG} alt={PRODUCT_ALT} className="mx-auto w-full max-w-[260px] object-contain drop-shadow-2xl transition-transform duration-200 ease-out hover:scale-[1.02] sm:max-w-sm" data-id="element-83" data-mp="3o5j39ad4ljlt" />
        </a>

        <CTAButton className="mx-auto mb-1.5 max-w-md" data-id="element-84" data-mp="30gzvqx1whaus">🚀 YES! I WANT MY SYSTEM NOW</CTAButton>

        <TrustRow guaranteeLabel="14-Day Money-Back Guarantee — Zero Risk" data-id="element-85" data-mp="358zu4l2bnvp9" />
      </div>
    </section>;
}